import $ from 'jquery';

export default () => {
  if ($('[data-collection-sort]').length === 0) {
    return;
  }

  $('[data-collection-sort]').on('change', (e) => {
    document.location.href = `https://${document.location.hostname}${document.location.pathname}?sort_by=${$(e.currentTarget).val()}`;
  });
};
